import { lazy, Suspense, useEffect, useRef, useState } from "react";

const LazyBlaze = lazy(() =>
	import("./canvasui/Blaze").then(({ Blaze }) => ({ default: Blaze })),
);

const DeferredFooterBlaze = () => {
	const hostRef = useRef<HTMLDivElement>(null);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const host = hostRef.current;
		if (!host) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (!entry?.isIntersecting) return;
				setVisible(true);
				observer.disconnect();
			},
			{ rootMargin: "400px 0px" },
		);

		observer.observe(host);
		return () => observer.disconnect();
	}, []);

	return (
		<div
			ref={hostRef}
			className="pointer-events-none absolute inset-x-0 bottom-0 -z-10 h-[calc(100%+60vh)]"
		>
			{visible && (
				<Suspense fallback={null}>
					<LazyBlaze
						className="size-full"
						distortion={0.3}
						distortionScale={0.3}
						glow={0.1}
						height={0.3}
						layers={4}
						smoke={0.45}
						smokeColor={[0.5098, 0.3647, 0.6392]}
						sparkColor={[0.4157, 0.4157, 0.4157]}
						sparkDensity={0.65}
						sparks={0.1}
						sparkSize={1}
						speed={1}
					>
						<div className="h-full" />
					</LazyBlaze>
				</Suspense>
			)}
		</div>
	);
};

export default DeferredFooterBlaze;
